import React from 'react';
import config from '../config';
import { isFunction } from '../libraries/utils';

class PushNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      OneSignal: null,
    }
  }
  
  componentDidMount() {
    window.OneSignal = window.OneSignal || [];
    if (process.env.NODE_ENV === 'production' && !isFunction(window.OneSignal.getNotificationPermission)) {
      const oneSignalScript = document.createElement("script");
      oneSignalScript.src = `https://cdn.onesignal.com/sdks/OneSignalSDK.js`; 
      oneSignalScript.async = true;
      window.document.body.appendChild(oneSignalScript);
      console.log('LOADING ONESIGNAL LIBRARY');
      oneSignalScript.addEventListener('load', () => {
        console.log('ONESIGNAL LIBRARY LOADED');
        this.init();
      });
    }
  }

  isPushNotificationsEnabledVerbose() {
    const { OneSignal } = this.state;
    if (!OneSignal) return;
    
    Promise.all([
      OneSignal.isPushNotificationsEnabled(),
      OneSignal.getUserId(),
      OneSignal.getRegistrationId(),
      OneSignal.getNotificationPermission(),
      OneSignal.isOptedOut(),
    ])
    .then(([isSubscribed, userId, registrationId, notificationPermission, optedOut]) => {
      console.warn('ONESIGNAL: Is Completely Subscribed:', isSubscribed);
      console.warn('ONESIGNAL: What is our OneSignal user ID?', userId);
      console.warn('ONESIGNAL: What is our push subscription token?', registrationId);
      console.warn('ONESIGNAL: What is the notification permission status?', notificationPermission);
      console.warn('ONESIGNAL: Are you manually opted out?', optedOut);
    })
    .catch(e => {
        console.error("Issue determining whether push is enabled:", e);
    });
  }  
  
  init = () => {
    console.log('INITIALIZE ONESIGNAL', this.props);
    const { user } = this.props;
    window.OneSignal = window.OneSignal || [];
    const OneSignal = window.OneSignal;

    const self = this;
    OneSignal.push(function() {
      OneSignal.SERVICE_WORKER_PARAM = { scope: '/onesignal/' };
      OneSignal.SERVICE_WORKER_PATH = 'onesignal/OneSignalSDKWorker.js'
      OneSignal.SERVICE_WORKER_UPDATER_PATH = 'onesignal/OneSignalSDKUpdaterWorker.js'
      OneSignal.init({
        // appId: "53a79def-0c73-4b65-90a6-031298fdbe20", // Production
        // appId: "d6944e1c-e070-48e8-865d-790fd1cf83b0",
        // safari_web_id: "web.onesignal.auto.1881b8be-1ae3-4d80-a99d-32f491a07c07", // Production
        // safari_web_id: "web.onesignal.auto.166712e5-2aee-41ea-b95e-8df3d8",
        appId: config.ONESIGNAL_APPID,
        safari_web_id: config.ONESIGNAL_SAFARI_WEB_ID,
        notifyButton: {
          enable: false,
        },
        welcomeNotification: {
          disable: true
        },
        // autoResubscribe: true,
        // requiresUserPrivacyConsent: true,
        // promptOptions: {
        //   slidedown: {
        //     enabled: true,
        //     autoPrompt: true,
        //     timeDelay: 10,
        //     pageViews: 2,
        //     actionMessage: "We'd like to show you notifications for the latest news and updates.",
        //     acceptButtonText: "ALLOW",
        //     cancelButtonText: "NO THANKS",
        //   }
        // },
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development' ? true : false,  // for local enviroment    
        // welcomeNotification: {
        //   "title": "One Signal",
        //   "message": "Thanks for subscribing!",
        // }
      });
      // OneSignal.showNativePrompt();

      OneSignal.log.setLevel('warn'); //trace
      OneSignal.registerForPushNotifications();
      if (user) {
        if (user.id && user.email) OneSignal.sendTags({ EXTERNAL_USER_ID: user.id, EMAIL: user.email});
        if (user.id) OneSignal.setExternalUserId(user.id);
        if (user.email) {
          OneSignal.setEmail(user.email)          
            .then(function(emailId) {
              // Callback called when email have finished sending
              console.log("ONESIGNAL: MAIL REGISTERED: ", emailId, user.email);
            }); 
          }
  
      }
      if (self) {
        self.setState({ OneSignal });
        self.isPushNotificationsEnabledVerbose();
      }
      //       OneSignal.push(function() {
      //           OneSignal.sendTags({
      //               latitude: latitude,
      //               long: longitude
      //           });
      //       });      
    });
  }

  render() {
    return null
  }
};

export default PushNotifications;